//global log holder
let logLines: string[] = [];

export function addLogLine(errorString: string) {
    const timeFormattedErrorString = (new Date().toISOString()) + ' - ' + errorString;
    // add to the global log holder
    logLines.push(timeFormattedErrorString);
}

export function getAllLogLines() {
    return logLines;
}

export function clearLogLines() {
    logLines = [];
}